import { render, staticRenderFns } from "./HealthScore.vue?vue&type=template&id=6d900b62&"
import script from "./HealthScore.vue?vue&type=script&lang=js&"
export * from "./HealthScore.vue?vue&type=script&lang=js&"
import style0 from "./HealthScore.vue?vue&type=style&index=0&id=6d900b62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports